import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CampusContext = createContext();

export const CAMPUS_OPTIONS = [
  { key: 'all', label: 'All Campuses', shortLabel: 'System-Wide', icon: 'fa-globe' },
  { key: 'knoxville', label: 'Knoxville', shortLabel: 'UTK', icon: 'fa-landmark' },
  { key: 'chattanooga', label: 'Chattanooga', shortLabel: 'UTC', icon: 'fa-mountain-city' },
  { key: 'martin', label: 'Martin', shortLabel: 'UTM', icon: 'fa-seedling' },
  { key: 'southern', label: 'Southern', shortLabel: 'UT Southern', icon: 'fa-location-dot' },
];

const STORAGE_KEY = 'campus_affiliation';

export const useCampus = () => {
  const context = useContext(CampusContext);
  if (!context) {
    throw new Error('useCampus must be used within a CampusProvider');
  }
  return context;
};

export const CampusProvider = ({ children }) => {
  const [campusAffiliation, setCampusAffiliationState] = useState(() => localStorage.getItem(STORAGE_KEY) || '');
  const [showCampusModal, setShowCampusModal] = useState(false);

  useEffect(() => {
    if (!campusAffiliation) {
      setShowCampusModal(true);
    }
  }, [campusAffiliation]);

  const setCampusAffiliation = (campusKey) => {
    localStorage.setItem(STORAGE_KEY, campusKey);
    setCampusAffiliationState(campusKey);
    setShowCampusModal(false);
  };

  const selectedCampus = useMemo(
    () => CAMPUS_OPTIONS.find(option => option.key === campusAffiliation) || null,
    [campusAffiliation]
  );

  const value = {
    campusAffiliation,
    campusLabel: selectedCampus?.label || '',
    campusShortLabel: selectedCampus?.shortLabel || '',
    selectedCampus,
    isAllCampuses: campusAffiliation === 'all',
    showCampusModal,
    setCampusAffiliation,
    openCampusModal: () => setShowCampusModal(true),
    closeCampusModal: () => setShowCampusModal(false),
  };

  return (
    <CampusContext.Provider value={value}>
      {children}
    </CampusContext.Provider>
  );
};
